import React, { createContext } from 'react';

const SearchContext = createContext({
  onChange: () => console.error('Unimplemented onChange for SearchContext'),
  searchScope: null,
});

export default SearchContext;
